import { render } from "./wListIcons.vue?vue&type=template&id=acd21c2e"
import script from "./wListIcons.vue?vue&type=script&lang=js"
export * from "./wListIcons.vue?vue&type=script&lang=js"

import exportComponent from "/Users/janbergler/NPM/MPM/V3/mpm/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__